import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-modal-loader',
  templateUrl: './modal-loader.component.html',
  styleUrls: ['./modal-loader.component.scss']
})
export class ModalLoaderComponent {
  @Input() title: string;

  @Input() message?: string;
}
